import { ReactIconsSpriteIcon } from "react-icons-sprite";
import { useGithubStars } from 'app/(public)/hooks/use-github-stars';
import { Button } from 'app/components/ui/button';

type GithubButtonProps = {
  className?: string;
  showStarCount?: boolean;
};

export const GithubButton = ({
  className,
  showStarCount = true,
}: GithubButtonProps) => {
  const { data: githubData } = useGithubStars();

  return (
    <a
      rel="noopener noreferrer"
      href="https://github.com/jurerotar/Pillage-First-Ask-Questions-Later"
      target="_blank"
      className={className}
    >
      <Button className="flex items-center gap-2">
        <ReactIconsSpriteIcon iconId="ri-react-icons-fa6-FaGithub" className="size-4" />
        GitHub
        {showStarCount && githubData?.starCount !== undefined && (
          <span className="flex items-center gap-1 ml-1 text-xs">
            <ReactIconsSpriteIcon iconId="ri-react-icons-fa6-FaStar" className="size-4" />
            {githubData.starCount}
          </span>
        )}
      </Button>
    </a>
  );
};
